import React from "react";
import leftArrow from "../assets/icons/left-arrow.svg";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

function PrivacyPolicy() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="global-component">
            <div className="jackpot_title">
                <img src={leftArrow}
                    alt="icon"
                    width={32}
                    height={32}
                    onClick={() => {
                        navigate('/more')
                    }}
                />
                <span>{t('Политика конфиденциальности')}</span>
            </div>
            <>
                {/* Заголовок + дата */}
                <div className="global-component_item">
                    <div className="global-component_item__content">
                        <p>
                            <a href="#" target="_blank" rel="noreferrer">
                                {t('CryptoLottery777')}
                            </a>{' '}
                            {t('уважает вашу конфиденциальность и обязуется защищать персональные данные, которые вы предоставляете при использовании нашего сайта и сервисов.')}
                        </p>
                        <p>
                            {t('Настоящая Политика конфиденциальности описывает, какие данные мы собираем, как мы их используем, передаём и защищаем.')}
                        </p>
                    </div>
                </div>

                {/* 1. Какие данные мы собираем */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('1. Какие данные мы собираем')}
                    </div>
                    <div className="global-component_item__content">
                        <p>{t('Мы можем собирать следующие данные:')}</p>
                        <ul>
                            <li>
                                <strong>{t('Адрес криптокошелька')}</strong>{' '}
                                {t('(wallet address)')}
                            </li>
                            <li>
                                <strong>{t('Электронная почта')}</strong>{' '}
                                {t('(если вы её указываете)')}
                            </li>
                            <li>
                                {t('IP-адрес и тип устройства')}
                            </li>
                            <li>
                                {t('Информация об использовании сайта (через cookies или инструменты аналитики)')}
                            </li>
                            <li>
                                {t('Партнёрская или реферальная информация (если вы участвуете в программе)')}
                            </li>
                        </ul>
                    </div>
                </div>

                {/* 2. Цели сбора данных */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('2. Цели сбора данных')}
                    </div>
                    <div className="global-component_item__content">
                        <p>{t('Мы используем данные для:')}</p>
                        <ul>
                            <li>
                                {t('Подключения и аутентификации через Web3-кошелёк')}
                            </li>
                            <li>
                                {t('Проведения розыгрышей и начисления выигрышей')}
                            </li>
                            <li>
                                {t('Участия в бонусных и реферальных программах')}
                            </li>
                            <li>
                                {t('Поддержания безопасности и предотвращения мошенничества')}
                            </li>
                            <li>
                                {t('Улучшения пользовательского опыта (через аналитику)')}
                            </li>
                            <li>
                                {t('Рассылки новостей, если вы подписались')}
                            </li>
                        </ul>
                    </div>
                </div>

                {/* 3. Передача данных третьим лицам */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('3. Передача данных третьим лицам')}
                    </div>
                    <div className="global-component_item__content">
                        <p>
                            {t('Мы не продаём ваши персональные данные. Однако мы можем передавать их:')}
                        </p>
                        <ul>
                            <li>
                                {t('Партнёрским платформам (например, блокчейн-провайдерам)')}
                            </li>
                            <li>
                                {t('Провайдерам аналитики (например, Google Analytics)')}
                            </li>
                            <li>
                                {t('По требованию и/или требованию государственных органов')}
                            </li>
                        </ul>
                        <p>
                            {t('Все передаваемые данные анонимизируются, если это возможно.')}
                        </p>
                    </div>
                </div>

                {/* 4. Cookies и аналитика */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('4. Cookies и аналитика')}
                    </div>
                    <div className="global-component_item__content">
                        <p>
                            {t('Мы используем cookies и другие технологии для сбора технической информации о вашем устройстве и сеансе. Вы можете отключить cookies в настройках своего браузера, однако это может ограничить функциональность сайта.')}
                        </p>
                    </div>
                </div>

                {/* 5. Хранение и защита данных */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('5. Хранение и защита данных')}
                    </div>
                    <div className="global-component_item__content">
                        <ul>
                            <li>{t('Все данные шифруются и хранятся на защищённых серверах.')}</li>
                            <li>{t('Доступ к данным ограничен и контролируется.')}</li>
                            <li>{t('Вы можете запросить удаление или изменение ваших данных, связавшись с нами.')}</li>
                        </ul>
                    </div>
                </div>

                {/* 6. Права пользователей */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('6. Права пользователей')}
                    </div>
                    <div className="global-component_item__content">
                        <p>{t('Вы имеете право:')}</p>
                        <ul>
                            <li>{t('Получить информацию о ваших данных')}</li>
                            <li>{t('Отозвать согласие на обработку')}</li>
                            <li>{t('Требовать удаления ваших данных')}</li>
                        </ul>
                        <p>
                            {t('Для этого свяжитесь с нами по адресу:')}{' '}
                            <a
                                href="mailto:lottowin777online@gmail.com?subject=Запрос%20по%20персональным%20данным"
                                className="global-component_item__content"
                            >
                                {t('lottowin777online@gmail.com')}
                            </a>
                        </p>
                    </div>
                </div>

                {/* 7. Изменения политики */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('7. Изменения политики')}
                    </div>
                    <div className="global-component_item__content">
                        <p>
                            {t('Мы можем обновлять данную Политику. Все изменения публикуются на этой странице с указанием даты вступления в силу. Мы рекомендуем регулярно проверять этот документ.')}
                        </p>
                    </div>
                </div>

                {/* 8. Контакты */}
                <div className="global-component_item">
                    <div className="global-component_item__title">
                        {t('8. Контакты')}
                    </div>
                    <div className="global-component_item__content">
                        <p>
                            {t('По вопросам, связанным с конфиденциальностью, обращайтесь:')}
                            <br />
                            {t('Email:')}{' '}
                            <a
                                href="mailto:lottowin777online@gmail.com?subject=Вопрос%20по%20политике%20конфиденциальности"
                                className="global-component_item__content"
                            >
                                {t('lottowin777online@gmail.com')}
                            </a>
                        </p>
                    </div>
                </div>

            </>
        </div>
    )
}

export default PrivacyPolicy